import http from '../../../app/services/httpServices';
import URL_UTILITY from '../../../app/utility/url.utility';

const getTaxRuleList = (context, payload) => {
  const url = URL_UTILITY.getTaxCategoryListUrl + "/rule-details";
  return http.getApi(url, payload);
};
export default {
  getTaxRuleList
};